module.exports = __webpack_public_path__ + "static/media/main-min.af4e61c4.jpg";